import { useEffect, useState } from 'react';
import Loading from '../../components/Loading';
import { Notification, notify } from '../../utils/notification';

import Voltar from '../../components/Links/Voltar';
import Titulo from '../../components/Texto/Titulo';
import ButtonToolbar from '../../components/Button/Toolbar';

import { connect } from 'react-redux';
import * as actions from '../../actions/upsells';

import moment from 'moment';

import { TextoDados } from '../../components/Texto/Dados';
import InputSimples from '../../components/Inputs/Simples';
import InputSelect from '../../components/Inputs/Select';
import SingleImage from '../../components/Imagens/Single';
import Table from '../../components/Table';
import { formatMoney, formatMoneyOnChange } from '../../utils'
import erpApi from '../../services/erpApi';

function Upsell({ admin, match, history, getUpsell, getUpsellProdutos, upsell, upsellProdutos, updateUpsell, deleteUpsell, updateUpsellImage, limparUpsell }) {

	const [upsellState, setUpsellState] = useState({});
	const [errors] = useState({});
	const [notification, setNotification] = useState("");
	const [erpConsultaLoading, setErpConsultaLoading] = useState(false);
	const [erpConsultaResultado, setErpConsultaResultado] = useState(null);
	const [erpIdValidado, setErpIdValidado] = useState(false);

	useEffect(() => {
		if(!upsell) {
			getUpsell(match.params.id, admin?.loja);
			getUpsellProdutos(match.params.id, admin?.loja);
		}
		if(upsell && Object.keys(upsellState).length === 0){
			upsell.preco = formatMoney(upsell.preco);
			// Se o upsell já tem um erpId salvo no banco, consideramos validado
			if (upsell.erpId) {
				setErpIdValidado(true);
			}
			return setUpsellState(upsell);
		}
	}, [match.params.id, upsell]);

	function removeUpsell() {
		if(window.confirm("Você realmente deseja excluir este upsell?")){
      if(upsellProdutos.docs.length >= 1) return notify("Impossível excluir, existem produtos utilizando este upsell no momento!", setNotification, "error")
			deleteUpsell(admin.nome, upsell._id, admin.loja, (err) => {
				if(err) return notify("Erro ao remover.", setNotification, "error")
				notify("Excluído com sucesso!", setNotification)
				window.scrollTo(0, 0);
        history.push("/upsells")
			});
		}
  }

  const onChangeInput = (field, value) => {
    // Se o campo for erpId, resetamos o estado de validação
    if (field === 'erpId') {
      setErpIdValidado(false);
      setErpConsultaResultado(null);
    }
    setUpsellState({ ...upsellState, [field]: value });
  }
  
  function handleUpdate(){
		if(!admin || !upsell) return null;
		updateUpsell(upsellState, upsell._id, admin.loja, (err) => {
			if(err) return notify("Erro ao atualizar as informações.", setNotification, "error")
			return notify("Atualizado com sucesso!", setNotification)
		});
  }
  
  function handleImageUpload(ev) {
		const data = new FormData();
		data.append("files", ev.target.files[0]);

		updateUpsellImage(data, upsell._id, admin.loja, (err) => {
			if(err) return notify("Erro ao atualizar a imagem!", setNotification, "error")
			return notify("Imagem atualizada!", setNotification)
		});
	}
	
	const consultarERP = async () => {
        const { erpId } = upsellState;
        
        if (!erpId) {
            return notify("Informe um ID no ERP para consultar", setNotification, "error");
        }
        
        setErpConsultaLoading(true);
        setErpConsultaResultado(null);
        setErpIdValidado(false);
        
        try {
            const resultado = await erpApi.getProdutoByCodigo(erpId);
            console.log("Resposta do ERP:", resultado);
            
            // Se a requisição foi bem-sucedida, mas a API retornou um erro de formato
            if (resultado && resultado.success === false && resultado.error?.message === "Formato de resposta inválido da API ERP") {
                setErpConsultaLoading(false);
                return notify("Formato de resposta inválido da API ERP", setNotification, "error");
            }
            
            if (resultado.success) {
                setErpConsultaResultado(resultado.data);
                setErpIdValidado(true);
                notify("Produto encontrado no ERP com sucesso!", setNotification, "success");
                
                // Auto-preencher campos com dados do ERP
                if (resultado.data && resultado.data.length > 0) {
                    const produtoERP = resultado.data[0];
                    setUpsellState({
                        ...upsellState,
                        titulo: produtoERP.nome || upsellState.titulo,
                        preco: produtoERP.preco ? formatMoney(produtoERP.preco) : upsellState.preco
                    });
                }
            } else {
                setErpIdValidado(false);
                notify(resultado.error?.message || "Produto não encontrado no ERP ou erro na consulta", setNotification, "error");
            }
        } catch (error) {
            console.error("Erro ao consultar ERP:", error);
            setErpIdValidado(false);
            notify(`Erro ao consultar ERP: ${error.message}`, setNotification, "error");
        } finally {
            setErpConsultaLoading(false);
        }
    }
    
    const renderErpConsultaResultado = () => {
        if (!erpConsultaResultado || erpConsultaResultado.length === 0) return null;
        
        const produto = erpConsultaResultado[0];
        console.log("Renderizando produto:", produto);
        
        // Verifique se o produto tem as propriedades necessárias
        if (!produto.nome && !produto.codigo) {
            return (
                <div style={{ marginTop: '15px', padding: '12px', backgroundColor: '#fff3e0', borderRadius: '4px', border: '1px solid #ffe0b2' }}>
                    <h4 style={{ fontSize: '14px', marginBottom: '8px', color: '#e65100' }}>Dados do produto incompletos</h4>
                    <div style={{ fontSize: '13px' }}>
                        Os dados do produto retornados pelo ERP estão incompletos ou em formato inesperado.
                    </div>
                </div>
            );
        }
        
        return (
            <div style={{ marginTop: '15px', padding: '12px', backgroundColor: '#f8f9fa', borderRadius: '4px', border: '1px solid #e9ecef' }}>
                <h4 style={{ fontSize: '14px', marginBottom: '8px', color: '#28a745' }}>Produto encontrado no ERP</h4>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', fontSize: '13px' }}>
                    {produto.codigo && (
                        <div>
                            <strong>Código:</strong> {produto.codigo}
                        </div>
                    )}
                    {produto.nome && (
                        <div>
                            <strong>Nome:</strong> {produto.nome}
                        </div>
                    )}
                    {produto.preco !== undefined && (
                        <div>
                            <strong>Preço:</strong> {formatMoney(produto.preco)}
                        </div>
                    )}
                    {produto.quantidade !== undefined && (
                        <div>
                            <strong>Estoque:</strong> {produto.quantidade}
                        </div>
                    )}
                </div>
            </div>
        );
    }
	
	const dados = [];
	(upsellProdutos ? upsellProdutos.docs : []).forEach((item) => {
		dados.push({
			"Produto": item.titulo,
			"Criado em": moment(item.createdAt).format("DD/MM/YYYY"),
			"Disponível": item.disponibilidade ? "Sim" : "Não",
			"Ações": `/produto/${item._id}`
		});
	});
	
	return !upsell ? <Loading /> : (
		<div className="Product container-centered">
			<div className="head">
				<Voltar history={history} historyPath={"/upsells/"} />
				<ButtonToolbar type="danger" label="Excluir" icon="fas fa-trash" onClick={() => removeUpsell()} />
			</div>
			<div className="content">
				<div className="Page-Title" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
					<Titulo tipo="h1" titulo={upsellState.titulo}/>
					<div className="ButtonSubmit">
						<button onClick={() => handleUpdate()}>Salvar</button>
					</div>
				</div>
				<Notification notification={notification} />
			
				<InputSimples type="text" value={upsellState.titulo} label="Nome" error={errors.titulo} onChange={(e) => onChangeInput("titulo", e.target.value)} />

				<InputSimples type="text" value={upsellState.preco} label="Preço" error={errors.preco} onChange={(e) => onChangeInput("preco", formatMoneyOnChange(e.target.value))} />

				<TextoDados chave="Disponíbilidade" valor={(
				<InputSelect nome="disponibilidade" value={upsellState.disponibilidade} opcoes={[
						{ label: "Disponível", value: true },
						{ label: "Indisponível", value: false }
					]} onChange={(ev) => onChangeInput("disponibilidade", ev.target.value)} />
				)} />
				
				<div style={{ display: 'flex', flexDirection: 'column', marginBottom: '20px' }}>
                    <div style={{ 
                        backgroundColor: erpIdValidado ? '#e6f7ed' : '#fff3e0', 
                        padding: '10px', 
                        borderRadius: '4px', 
                        marginBottom: '10px',
                        border: erpIdValidado ? '1px solid #a3d8b5' : '1px solid #ffe0b2',
                        transition: 'background-color 0.3s ease, border-color 0.3s ease'
                    }}>
                        <div style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            marginBottom: '5px',
                            color: erpIdValidado ? '#2e7d32' : '#e65100'
                        }}>
                            <i className={erpIdValidado ? "fas fa-check-circle" : "fas fa-exclamation-triangle"} 
                               style={{ marginRight: '8px' }}></i>
                            <strong>{erpIdValidado ? "Integração com ERP configurada" : "Atenção! Upsell sem integração com ERP"}</strong>
                        </div>
                        <p style={{ fontSize: '12px', margin: '0' }}>
                            {erpIdValidado 
                                ? "Este upsell está corretamente configurado para integração com o ERP." 
                                : "Upsells sem ID no ERP validado não poderão ser integrados automaticamente nas vendas."}
                        </p>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                        <div style={{ flex: 1 }}>
                            <InputSimples 
                                label="ID no ERP" 
                                error={errors.erpId} 
                                value={upsellState.erpId || ""}
                                onChange={(e) => onChangeInput("erpId", e.target.value)}
                                style={{ 
                                    borderColor: erpIdValidado ? '#a3d8b5' : '#ffe0b2',
                                    backgroundColor: erpIdValidado ? '#f5fff9' : '#fffaf0',
                                    transition: 'background-color 0.3s ease, border-color 0.3s ease'
                                }}
                            />
                        </div>
                        <div style={{ marginTop: '40px' }}>
                            <button 
                                onClick={consultarERP}
                                disabled={erpConsultaLoading}
                                style={{ 
                                    padding: '6px 12px', 
                                    backgroundColor: '#f0f0f0', 
                                    color: '#333', 
                                    border: '1px solid #ccc', 
                                    borderRadius: '4px',
                                    cursor: erpConsultaLoading ? 'wait' : 'pointer',
                                    fontSize: '13px'
                                }}
                            >
                                {erpConsultaLoading ? 'Consultando...' : 'Consultar'}
                            </button>
                        </div>
                    </div>
                </div>
                
                {renderErpConsultaResultado()}

				{ upsell.fotos && <SingleImage image={upsell.fotos[0]} handleSubmit={handleImageUpload} />}
				
				<div className="upsell-products">
					<h2>Produtos conectados</h2>
					{ upsellProdutos && upsellProdutos.total > 0 ? (
						<>
							<Table cabecalho={["Produto", "Criado em", "Disponível"]} dados={dados} gridClass="Products productsUpsell" />
						</>
					) : (<h2 className="NotFoundData">Este Upsell não está sendo utilizado ainda.</h2>)}
				</div>

				</div>
		</div>
	)
}

const mapStateToProps = state => ({
  upsell: state.upsell.upsell,
  upsellProdutos: state.upsell.upsellProdutos,
	admin: state.auth.usuario
});

export default connect(mapStateToProps, actions)(Upsell);